export const MAX_IMAGE_MB = 25;

export interface ImageFileLike {
  name: string;
  type: string;
  size: number;
}

export type ImageValidationResult = { ok: true } | { ok: false; message: string };

const HEIC_TYPES = ['image/heic', 'image/heif', 'image/heic-sequence', 'image/heif-sequence'];
const HEIC_EXT = /\.(heic|heif)$/i;

export function validateImageFile(
  file: ImageFileLike,
  maxSizeMB: number = MAX_IMAGE_MB
): ImageValidationResult {
  // Moet vóór de generieke image/*-check staan: anders krijgt image/heic die generieke melding.
  if (HEIC_TYPES.includes(file.type.toLowerCase()) || HEIC_EXT.test(file.name)) {
    return {
      ok: false,
      message:
        'Deze foto staat in HEIC-formaat en dat kan de browser niet lezen. Stuur de foto naar jezelf als JPG, of zet in de camera-instellingen van je iPhone "Meest compatibel" aan.',
    };
  }

  if (!file.type.startsWith('image/')) {
    return {
      ok: false,
      message: 'Dit bestand is geen afbeelding. Gebruik een JPG, PNG of WebP.',
    };
  }

  if (file.size > maxSizeMB * 1024 * 1024) {
    return {
      ok: false,
      message: `Deze afbeelding is groter dan ${maxSizeMB}MB. Verklein de foto en probeer het opnieuw.`,
    };
  }

  return { ok: true };
}
